import React from 'react';
import { useState } from 'react';
import axios from 'axios';


async function loginUser(username, password, setToken, setAuthError, setAppUserName) {

  let credentials = {"username": username, "password": password};
  let authUrl = process.env.REACT_APP_API_URL + '/expert_token_auth/';

  axios.post(authUrl, credentials)
  //axios.post(`http://srv-ias05-test.fsvok.ru/api/token_auth/`,  credentials)
  .then(
    (result) => {
      setToken(result.data.token);
      localStorage.setItem('authToken', result.data.token);
      setAppUserName(username);
      localStorage.setItem('username', username);
    },
    (error) => {
      setAuthError(true);
      console.log(error);
    }
  );
}
 
export default function Login({ setToken, setAppUserName }) {
  const [username, setUserName] = useState();
  const [password, setPassword] = useState();
  const [authError, setAuthError] = useState(false);
 
  const handleSubmit = async e => {
    e.preventDefault();
    // eslint-disable-next-line no-unused-vars
    let token = await loginUser(username, password, setToken, setAuthError, setAppUserName);
  }

  return(
    <>
      <nav className="navbar navbar-dark bg-opacity-75 bg-gradient fixed-top fsvok2">
        <div className="container-fluid px-5">
          <a className="navbar-brand lk-navbar-link" href="/">ФСВОК | кабинет эксперта </a>
        </div>
      </nav>
      <div className="container">
        <div className="row plato">
          <div className="col-4"></div>
            <div className="col-3 mt-5">
              <form onSubmit={handleSubmit}>
                <label className="mt-5">
                  <p>Логин</p>
                  <input type="text" onChange={e => setUserName(e.target.value)}/>
                </label>
                <label className="mt-3">
                  <p>Пароль</p>
                  <input type="password" onChange={e => setPassword(e.target.value)}/>
                </label>
                <div className="mt-3 ">
                  <button className="lk-button px-4" type="submit">Вход</button>
                </div>
                {authError === true ? <p className="text-danger mt-4">неверный логин или пароль</p> : <p></p>}
              </form>
            </div>
          <div className="col-4"></div>
        </div>
      </div>
    </>
  );
}
